import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

export const campSfNew: FaireAdCampaignEntity = {
  token: "camp_sf_new",
  type: "adCampaign",
  advertiserProfileToken: "adv_shady_front",
  segment: "NEW_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 4800,
  startedRunningAt: "2024-10-11",
  segmentMetrics: {
    numCustomersAcquired: 391,
    salesDollars: 256895,
    totalAdsSpendDollars: 31487,
    cpaDollars: 80.53,
    bestEstimateSalesDollars: 302248,
    bestEstimateRoas: 9.6,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-27T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
